// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'neueMontreal', 'neueMontreal Fallback'"},"className":"__className_1bdcd1","variable":"__variable_1bdcd1"};